export default "__VITE_ASSET__DVxJ2ckw__";